import { Button, Container, Typography } from '@material-ui/core';
import React from 'react';
import { getUserManager } from "../authentication-service.js";
import { authenticateUser } from "../oidc-service.js";
export const SessionLost = _ref => {
  let {
    onAuthenticate
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, {
    maxWidth: "sm"
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "h1",
    gutterBottom: true
  }, "Session timed out"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Your session has expired. Please re-authenticate yourself."), /*#__PURE__*/React.createElement(Button, {
    onClick: onAuthenticate
  }, "re-authenticate"));
};
export const SessionLostContainer = _ref2 => {
  let {
    history,
    SessionLostComponentOverride
  } = _ref2;
  const callbackPath = history.location.search.replace('?path=', '');

  const onAuthenticate = () => {
    authenticateUser(getUserManager(), history.location, history)(true, callbackPath);
  };

  return SessionLostComponentOverride ? /*#__PURE__*/React.createElement(SessionLostComponentOverride, {
    onAuthenticate: onAuthenticate
  }) : /*#__PURE__*/React.createElement(SessionLost, {
    onAuthenticate: onAuthenticate
  });
};
//# sourceMappingURL=session-lost.js.map